import { useMemo } from 'react';
import { GuidelinePublicCompaniesAttributes } from 'pages/ValuationsAllocation/types';

export const useCombinedGPCComparisonPerfMetricAttrs = (gpcAttributes?: GuidelinePublicCompaniesAttributes | null) =>
  useMemo(() => {
    if (!gpcAttributes) {
      return {};
    }
    const { comparisonAttrs, customDatePerformanceMetricAttrs } = gpcAttributes;
    return {
      ...comparisonAttrs,
      ...customDatePerformanceMetricAttrs,
    };
  }, [gpcAttributes]);
